import { z } from "zod";

const schema = z.object({
  milestone: z.string({
    required_error: "You must select a milestone",
  }),
  completionDate: z.date(),
});

type Schema = z.infer<typeof schema>;

export {
  schema as milestoneCompletionFormSchema,
  type Schema as MilestoneCompletionFormSchema,
};
